module.exports = __webpack_public_path__ + "img/VocabularyPageTitleBackground.98ee1988.jpg";